/**
 * Describes whether peg is static or floats
 * tag: 835
 * @readonly
 * @enum {number} (int)
 */
export enum PegMoveType {
  /** Floating (default) */
  Floating = 0,
  /** Fixed */
  Fixed = 1,
}
